// extracted by mini-css-extract-plugin
export default {"loadingScreen":"styles_loadingScreen__nat2m","messageLoading":"styles_messageLoading__vexyH"};